export default "<p>\n  output-graph works!\n</p>\n<button (click)=\"add()\">Add Point!</button>\n<div [chart]=\"stock\"></div>\n"